import {
    SET_CONTACT,

    SET_ERROR, SET_GRID, SET_HINT,
    SET_LOADING,
    SET_RESET, SET_Slider, SET_SOCIAL, SET_TOPIC_NEWS, SET_WHY
} from "./mutation_types";

export default {
    [SET_WHY](state, why) {
        state.why = why.data;
    },
    [SET_Slider](state, slider) {
        state.slider = slider.data;
    },
    [SET_GRID](state, grid) {
        state.grid = grid.data;
    },
    [SET_HINT](state, hint) {
        state.hint = hint.data;
    },
    [SET_TOPIC_NEWS](state, topicNews) {
        state.topicNews = topicNews.data;
    },
    [SET_CONTACT](state, resource) {
        state.contactDetails = resource.data.details;
    },
    [SET_SOCIAL](state, resource) {
        state.socialMedia = resource.data.details;
    },

    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
    [SET_RESET](state) {
        state.mornsunResource = [];
        state.resource = [];
        state.chinaResource = [];
        state.mouserResource = [];
    }
};

